import ApiGateway from "./ApiGateway";

class ApiRequestBuilder {
    constructor() {
        this._requests = [];
        this._counter = 0;
        this._maxCounter = 0;
        this._callback = null;
    }
    addPost(service, data) {
        this._requests.push({
            method: 'POST',
            service: service,
            data: data || {}
        });
        return this;
    }
    addGet(service) {
        this._requests.push({
            method: 'GET',
            service: service,
            data: null
        });
        return this;
    }
    execute(callback) {
        this._callback = callback;
        this._maxCounter = this._requests.length;
        for(var i = 0; i < this._requests.length; i++) {
            this._manageRequest(this._requests[i]);            
        }
    }

    _manageResponseList(request, response) {
        this._counter++;
        request.response = response;
        if(this._counter >= this._maxCounter) {
            var responses = [];
            for(var i = 0; i < this._requests.length; i++) {
                responses.push(this._requests[i].response);
            }
            if(this._callback !== undefined && this._callback !== null) {
                this._callback(responses);
            }
        }
    }
    _manageRequest(requestObject) {
        const request = requestObject;
        const pointer = this;
        if(request.method === 'POST') {
            ApiGateway.post(request.service, request.data, (response) => {
                pointer._manageResponseList(request, response);
            });
        }
        else {
            ApiGateway.get(request.service, request.data, (response) => {
                pointer._manageResponseList(request, response);
            });
        }
    }
}
export default ApiRequestBuilder;